<script setup>
import { useRoute } from "vue-router";
const route = useRoute();
</script>
<template>
  <header>
    <HeaderNotification v-if="isHomeView" :message="content.notification" />
    <nav class="site-nav dark js-site-navbar site-navbar-target" style="z-index: 999;">
      <div class="container">
        <div class="site-navigation">
          <a href="/" class="logo m-0 float-left">
            <!-- <img loading="lazy" :src="'https://measiteassetpublic.zohostratus.in/img/MEA Logo SVG.svg'" alt="MEA Service" /> -->
            <!-- <img loading="lazy" :src="'https://measiteassetpublic.zohostratus.in/img/header.svg'" alt="MEA Service" /> -->
            <img loading="eager" fetchpriority="high" :width="content.logo.width" :height="content.logo.height" :src="content.logo.src" :alt="content.logo.alt" />
          </a>

          <!-- The first item was an <a href> reading its label from i18n while
               the other two were router-links with the label typed in. They are
               one list now; `to` decides which is which, so the home link keeps
               its full page load and the others stay client-side. -->
          <ul class="js-clone-nav d-none d-lg-inline-block site-menu float-left">
            <li v-for="item in content.navigation" :key="item.key" :class="currentPage === item.key ? 'active' : ''">
              <a v-if="item.to === '/'" :href="item.to" class="nav-link">{{ item.label }}</a>
              <router-link v-else :to="item.to" class="nav-link">{{ item.label }}</router-link>
            </li>
            <!-- <li class="active">
              <a href="" class="nav-link">Solutions</a>
            </li> -->
            <!-- <li>
              <a
                href="#"
                class="nav-link"
                @click.prevent="forceReload"
              >
                {{ $t("header['site_navigation'][1]") }}
              </a>
            </li>
            <li>
              <a href="#" class="nav-link">{{
                $t("header['site_navigation'][2]")
              }}</a>
            </li>
            <li>
              <a href="#" class="nav-link">{{
                $t("header['site_navigation'][3]")
              }}</a>
            </li> -->
          </ul>

          <ul class="js-clone-nav d-none d-lg-inline-block site-menu float-right credential">
            <li class="cta-button-group">
              <!-- <button class="cta-global-language" href="">
                <i class="bx bx-globe"></i
                >{{ $t("header['button_group'][0]['globe']") }}
              </button> -->
              <!-- <button class="cta-login" @click="redirectToLogin" v-if="!userFound">
                {{ $t("header['button_group'][0]['login']") }}
              </button> -->
              <!-- <div v-else style="display: flex; justify-content: center; align-items: center; height: 40px;">
                <img loading="lazy" src="https://measiteassetpublic.zohostratus.in/img/index/user-thumbnail.png" style="width: 34px; height: 34px;" />
              </div> -->
              <div class="user-wrapper" ref="wrapper" v-if="userFound">
                <!-- <img loading="lazy" src="https://measiteassetpublic.zohostratus.in/img/index/user-thumbnail.png"
                  class="user-avatar"
                  @click="toggle"
                /> -->
                <img width="102" height="103" loading="lazy" src="https://measiteassetpublic.zohostratus.in/designFiles/user-thumbnail.png" class="user-avatar"
                  @click="toggle" />

                <transition name="popover">
                  <div v-if="open" class="popover">
                    <div class="popover-header">
                      <!-- <img loading="lazy" src="https://measiteassetpublic.zohostratus.in/img/index/user-thumbnail.png" /> -->
                      <img width="102" height="103" loading="lazy" src="https://measiteassetpublic.zohostratus.in/designFiles/user-thumbnail.png" />
                      <!-- <img loading="lazy" src="https://contacts.zoho.in/file?t=user&fs=thumb&ID=60044028546" /> -->
                      <div>
                        <div class="name">{{ userName }}</div>
                        <div class="role">{{ userEmail }}</div>
                      </div>
                    </div>

                    <div class="popover-footer">
                      <a href="#"></a>
                      <a href="#" class="logout" @click="signOutUser">{{ content.signOut }}</a>
                    </div>
                  </div>
                </transition>
              </div>
            </li>
          </ul>

          <a href="#" class="burger ml-auto float-right site-menu-toggle js-menu-toggle d-inline-block dark d-lg-none"
            :class="menuDrawer ? 'active' : ''" data-toggle="collapse" data-target="#main-navbar"
            @click="toggleMenuDrawer()">
            <span> </span>
            <div class="site-mobile-menu site-navbar-target header-menu-drawer" :class="menuDrawer ? 'active' : ''">
              <div class="site-mobile-menu-header">
                <div class="site-mobile-menu-close">
                  <span class="icofont-close js-menu-toggle"></span>
                </div>
              </div>
              <div class="site-mobile-menu-body"></div>
            </div>
          </a>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
import { getCurrentProjectUser } from "@/services/currentUser";
import { isLoginRemoved } from "@/services/authControl";
import HeaderNotification from "./HeaderNotification.vue";
import homeContent from "@/assets/home-content.json";
export default {
  name: "HomeHeader",
  components: {
    HeaderNotification,
  },
  props: {
    // Defaulted: nine other views render this header without passing anything.
    content: {
      type: Object,
      default: () => homeContent.HomeHeader
    }
  },

  data() {
    return {
      isHomeView: true,
      menuDrawer: false,
      currentPage: "",
      userFound: false,
      userName: "",
      userEmail: "",
      open: false
    };
  },
  watch: {
    menuDrawer(newVal) {
      if (newVal) {
        document.body.classList.add("offcanvas-menu");
      } else {
        document.body.classList.remove("offcanvas-menu");
      }
    },
  },
  async mounted() {
    await this.authenticateUser();
    this.currentPage = this.$route.name;
    this.isHomeView = this.currentPage === "home" || this.currentPage === "solutions" || this.currentPage === "customers";
    document.addEventListener("click", this.handleOutside);
    this.applyZsiqStyle('block');
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleOutside);
    this.removeZsiqStyle();
  },
  methods: {
    // async authenticateUser() {
    // 	var userManagement = catalyst.userManagement;
    // 	try {
    // 		var currentUserPromise = await userManagement.getCurrentProjectUser();
    // 		this.userFound = true;
    //     if (currentUserPromise.content.first_name) {
    //       this.userName = currentUserPromise.content.first_name;
    //     }
    //     if (currentUserPromise.content.last_name) {
    //       this.userName += " " + currentUserPromise.content.last_name;
    //     }
    // 		this.userEmail = currentUserPromise.content.role_details.role_name;
    //     // console.log("Authenticated: ", currentUserPromise);
    //     // console.log("Authenticated: ", currentUserPromise.content);

    //     const loginUserDetails = {
    //       userName: this.userName,
    //       userRole: this.userEmail,
    //       userEmail: currentUserPromise.content.email_id
    //     }

    //     this.$store.commit('setLoginUserDetails', loginUserDetails)
    //   } catch (e) {
    //     // console.log("Authentication Error: ", e);
    //     this.$router.push('/login')
    //   }
    // },
    async authenticateUser() {
      const currentPath = this.$route.path;

      // Skip authentication for Zoho Books training route
      if (currentPath.startsWith('/training/validate/') || currentPath.startsWith('/training/validate')) {
        return;
      }

      try {
        // F5: shared with main.js. This mount used to issue a second
        // project-user/current request (measured at 3.89s, after main.js's at
        // 1.69s); the service returns the already-resolved result instead.
        var currentUserPromise = await getCurrentProjectUser();

        this.userFound = true;

        // Build user name safely
        this.userName = '';
        if (currentUserPromise.content.first_name) {
          this.userName = currentUserPromise.content.first_name;
        }
        if (currentUserPromise.content.last_name) {
          this.userName += (this.userName ? ' ' : '') + currentUserPromise.content.last_name;
        }

        this.userEmail = currentUserPromise.content.role_details.role_name;

        const loginUserDetails = {
          userName: this.userName,
          userRole: this.userEmail,
          userEmail: currentUserPromise.content.email_id
        };

        this.$store.commit('setLoginUserDetails', loginUserDetails);

      } catch (e) {
        // AUTH_CONTROL kill switch: while RemoveLogin is active the site is
        // meant to be browsable signed out, so a failed lookup is the expected
        // state and must not bounce the visitor to the sign-in page. The header
        // simply renders its logged-out variant.
        if (isLoginRemoved()) {
          this.userFound = false;
          return;
        }

        // Redirect only if not in skipped route (extra safety)
        if (!currentPath.startsWith('/training/validate/') || currentPath.startsWith('/training/validate')) {
          this.$router.push('/login');
        }
      }
    },
    applyZsiqStyle(display) {
      this.removeZsiqStyle();

      const style = document.createElement('style');
      style.id = 'zsiq-style-toggle';
      style.innerHTML = `
        .zsiq-flexM, .zsiq-iflexM {
          display: ${display} !important;
        }
      `;
      document.head.appendChild(style);
    },

    removeZsiqStyle() {
      const existing = document.getElementById('zsiq-style-toggle');
      if (existing) existing.remove();
    },
    toggle() {
      this.open = !this.open;
    },
    handleOutside(e) {
      if (!this.$refs.wrapper.contains(e.target)) {
        this.open = false;
      }
    },
    toggleMenuDrawer() {
      // console.log(this.menuDrawer);

      this.menuDrawer = !this.menuDrawer;
    },
    redirectToLogin() {
      this.$router.push('/login');
    },
    forceReload() {
      const baseUrl = window.location.origin;
      window.location.href = `${baseUrl}/#/20325000000020646`;
      setTimeout(() => {
        window.location.reload();
      }, 100);
    },
    signOutUser() {
      var redirectURL = window.location.origin;
      //Use the redirect url and call the method to sign out
      var auth = catalyst.auth;
      auth.signOut(redirectURL);
    }
  },
};
</script>

<style>
.active .nav-link {
  color: #0172F5 !important;
  font-weight: bold;
}

.nav-link {
  color: #2E2E2E !important;
}

.site-mobile-menu .site-nav-wrap {
  list-style: none;
  padding: 0;
  margin: 0 0 20px 0;
}

.site-mobile-menu .cta-global-language {
  display: none;
}

.site-mobile-menu .site-nav-wrap li {
  margin-bottom: 15px;
}

.site-mobile-menu .site-nav-wrap li a.nav-link {
  display: block;
  padding: 12px 20px;
  text-decoration: none;
  color: #333;
  background-color: #f8f9fa;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.site-mobile-menu .site-nav-wrap li a.nav-link:hover,
.site-mobile-menu .site-nav-wrap li.active a.nav-link {
  background-color: #007bff;
  color: #fff;
}

.site-mobile-menu .cta-button-group {
  display: flex;
  gap: 10px;
  padding: 10px 0;
  margin-top: 24px;
  justify-content: center;
  align-items: center;
}

.site-mobile-menu .cta-button-group button {
  padding: 10px 16px;
  font-size: 15px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: background 0.3s;
}

.site-mobile-menu .cta-button-group button i {
  margin-right: 6px;
  font-size: 16px;
  vertical-align: middle;
}

.site-mobile-menu .cta-button-group button:first-child {
  background-color: #e9ecef;
  color: #333;
}

.site-mobile-menu .cta-button-group button:first-child:hover {
  background-color: #d6d8db;
}

.site-mobile-menu .cta-button-group .cta-login {
  background-color: #007bff;
  color: #fff;
}

.site-mobile-menu .cta-button-group .cta-login:hover {
  background-color: #0056b3;
}

.user-wrapper {
  position: relative;
  display: inline-block;
}

.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
}

/* Popover box */
.popover {
  position: absolute;
  top: 55px;
  right: 0;
  width: 260px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  padding: 14px;
  z-index: 10;
}

/* Arrow */
.popover::before {
  content: "";
  position: absolute;
  top: -8px;
  right: 20px;
  width: 16px;
  height: 16px;
  background: #fff;
  transform: rotate(45deg);
}

/* Header */
.popover-header {
  display: flex;
  gap: 12px;
  align-items: center;
  padding-bottom: 12px;
  border-bottom: 1px solid #eee;
}

.popover-header img {
  width: 48px;
  height: 48px;
  border-radius: 6px;
}

.name {
  font-weight: 600;
}

.role {
  font-size: 13px;
  color: #666;
}

/* Footer */
.popover-footer {
  display: flex;
  justify-content: space-between;
  padding-top: 12px;
}

.popover-footer a {
  font-size: 14px;
  text-decoration: none;
  color: #2563eb;
}

.logout {
  color: #ef4444 !important;
}

/* ✨ Animation */
.popover-enter-active,
.popover-leave-active {
  transition: all 0.25s ease;
}

.popover-enter-from,
.popover-leave-to {
  opacity: 0;
  transform: translateY(-10px) scale(0.95);
}

/* .zsiq-flexM, .zsiq-iflexM {
    display: none !important;
  } */
</style>